import React, {useMemo} from 'react'
import {UIGameTimer} from './UIGameTimer'
import {useGameStore} from '../../store/GameStoreContext'
import {useGameValidator} from '../../store/selectors/useGameValidator'
import {useIsGameEnded} from '../../store/selectors/useIsGameEnded'

interface UIGameTimerContainerProps {
    timerStyle: 'white' | 'beige'
    className?: string | undefined
}

export const UIGameTimerContainer = ({
    timerStyle,
    className,
}: UIGameTimerContainerProps) => {
    const timeLeftInSeconds = useGameStore((state) => state.timeLeftInSeconds)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const gameValidator = useGameValidator()
    const myColor = useGameStore((state) => state.myColor)
    const isGameEnded = useIsGameEnded()

    const isMyPlayerTakingAction = useMemo(() => {
        if(isGameEnded) return false

        const playersTakingAction = gameValidator.getPlayersTakingAction()
        return playersTakingAction.includes(myColor)
    }, [gameValidator, myColor])

    return <UIGameTimer
        className={className}
        timeLeftInSeconds={timeLeftInSeconds}
        isMyPlayerTakingAction={isMyPlayerTakingAction}
        isPaused={isPaused}
        timerStyle={timerStyle} />
}
